import { ReactElement, useCallback } from 'react';
import styles from './users-deleted.page.module.scss';
import { H2 } from '@blueprintjs/core';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UsersTable, UsersTableQuery } from '../../../users/components';

export function UsersDeletedPage(): ReactElement {
	const [searchParams, setSearchParams] = useSearchParams();
	const navigate = useNavigate();

	const onQueryChange = useCallback(
		(query: UsersTableQuery) => {
			const searchParams: any = {};
			if (query.offset !== undefined) {
				searchParams.offset = query.offset.toString();
			}
			if (query.sortBy !== undefined) {
				searchParams.sortBy = query.sortBy;
			}
			if (query.sortOrder !== undefined) {
				searchParams.sortOrder = query.sortOrder;
			}
			setSearchParams(searchParams);
		},
		[setSearchParams]
	);

	return (
		<div className={styles.container}>
			<div className={styles.headerContainer}>
				<H2>Deleted users</H2>
			</div>
			<UsersTable
				initialQuery={{
					offset: Number(searchParams.get('offset')) || undefined,
					sortBy: (searchParams.get('sortBy') as any) || undefined,
					sortOrder: (searchParams.get('sortOrder') as any) || undefined
				}}
				onQueryChange={onQueryChange}
				onUserClick={(user) => navigate(`/users/${user.id}`)}
				showDeleted
			/>
		</div>
	);
}
